import React from 'react';
import Slider from 'react-slick';
import * as S from './style';
import { SectionLayout } from '../../components/Layouts';
import Icon from '../../components/Icon';
import { Col, Row } from '../../components/Grid';
import * as T from '../../components/Typography';
import composeStyle from '../../utils/composeStyle';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Content = composeStyle(T.H4, 'H4', 'P20Bold');

const Carousal = ({ data }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    prevArrow: (
      <S.Button type="button" className="button button--text button--icon" aria-label="prev">
        <S.PrevArrow>
          <Icon icon="leftArrow" width="22px" height="22px" to="prev" color="white" />
        </S.PrevArrow>
      </S.Button>
    ),
    nextArrow: (
      <S.Button type="button" className="button button--text button--icon" aria-label="next">
        <S.NextArrow>
          <Icon icon="leftArrow" width="22px" height="22px" to="prev" color="white" />
        </S.NextArrow>
      </S.Button>
    ),
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <SectionLayout bgcolor="blueGrad">
      <Row jc="center" jcM="flex-end">
        <Col w={[4, 6, 11.5]}>
          <S.SliderWrapper>
            <Slider {...settings}>
              {data.map(
                q =>
                  q.content && (
                    <Row py="128px" jc="center">
                      <Col w={[4, 6, 9]} mx="auto">
                        <S.Quote>
                          <Content color="white" as="pre">
                            {q.content}
                          </Content>
                          <S.Author>
                            <T.H5 color="white">{q.author}</T.H5>
                            <T.Body16 color="gray4">{q.location}</T.Body16>
                          </S.Author>
                          <S.QuoteContainer>
                            <Icon icon="quote" color="white" />
                          </S.QuoteContainer>
                        </S.Quote>
                      </Col>
                    </Row>
                  ),
              )}
            </Slider>
          </S.SliderWrapper>
        </Col>
      </Row>
    </SectionLayout>
  );
};

export default Carousal;
